import React from 'react';
import {AppFormLayout,AppForm,AppFormPageProps,AppFormItemEnum} from 'qcc'
import api, {PosFund} from "api";

let posAppSceneOption = [
    {label:'收筹金',value:'scj'},
    {label:'收楼款',value:'slk'},
    {label:'收代收费用',value:'sdsf'},
    {label:'收补差款',value:'sbck'},
    {label:'收服务费',value:'sfwf'},
    {label:'收滞纳金',value:'znj'}
]


export default class EditForm extends React.PureComponent<AppFormPageProps> {
    state = {}

    save = async (formData?:PosFund) =>{
        let{type} = formData;
        if(type === 1) {
            let {fundName,fundTypeName} = formData;
            let fundFullName = fundTypeName + '-' + fundName;
            formData = {...formData,fundFullName}
        }
        
        return this.props.mode === 1 ? await api.posfund.create(formData):await api.posfund.update(formData);
    }
	render() {
		let {formData,mode,id} = this.props;
		return (<AppFormLayout defaultButton mode={this.props.mode}>
            <AppFormLayout.Form>
                <AppForm entity='pos_fund' loadingData={false} mode={mode} keyValue={id} formData={formData} 
                save = {this.save}
                afterSave={()=>{this.props.afterSave && this.props.afterSave()}}>
                    <AppForm.Section labelWidth={120}>
                        <AppForm.Item label={this.props.formData.type ===0?'款项类型':'款项名称'} 
                        field='fundName' 
                        itemType={AppFormItemEnum.input}  req  />
                        <AppForm.Item label="款项编码" 
                        field='fundCode' placeholder="请输入与ERP编码一致，该信息用于匹配ERP款项" 
                        itemType={AppFormItemEnum.input}  req  />
                         <AppForm.Item label="智能POS收款场景" 
                        field='posAppScene' placeholder="请选择智能POS对应收款的场景" 
                        itemType={AppFormItemEnum.select} options={posAppSceneOption} req  />
                    </AppForm.Section>
                </AppForm>
            </AppFormLayout.Form>
        </AppFormLayout>
	    )
	}

}


// WEBPACK FOOTER //
// ./src/page/pos/fund/EditForm.tsx